import get from 'lodash/get';
import {
  getBpApiClientHeaders,
  getRequestCorrelation,
  getSessionCorrelationFromReq,
  getSharedHeaders,
} from './';

export const getServerRequestHeaders = (req = {}) => ({
  ...getRequestCorrelation(req),
  ...getSessionCorrelationFromReq(req),
  ...getSharedHeaders(req),
  ...getBpApiClientHeaders(global.env),
  ...(get(req, 'query.synthetic') === 'true'
    ? {
        'x-hsbc-application-type': 'ntb_ao_synth',
      }
    : {}),
});
